import { MapPin, Smartphone, MessageCircle } from "lucide-react";
import { buildWhatsappLink } from "@/lib/constants";

const items = [
  {
    icon: MapPin,
    t: "SEO técnico",
    d: "Metadados, performance, estrutura semântica e bases técnicas para empresas serem encontradas.",
  },
  {
    icon: Smartphone,
    t: "Sites leves & rápidos",
    d: "Experiência pensada para mobile para decisores que pesquisam fornecedores no telemóvel.",
  },
  {
    icon: MessageCircle,
    t: "Captação de leads",
    d: "Formulários, WhatsApp, tracking e CTAs pensados para transformar visitas em conversas comerciais.",
  },
];

const LocalBusiness = () => {
  return (
    <section
      id="local"
      data-testid="local-business-section"
      className="bg-[#f8f5ee] py-24 md:py-32"
    >
      <div className="max-w-[1300px] mx-auto px-5 sm:px-8">
        <div
          className="bg-[#0a0a0a] border-[6px] border-[#ff6b35] p-8 sm:p-14 brutal-shadow-orange relative overflow-hidden"
        >
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#ff6b35]/20 rounded-full blur-2xl" />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 relative">
            <div className="lg:col-span-5">
              <div className="inline-block bg-[#ff6b35] text-[#0a0a0a] px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-5">
                ✦ Para empresas em Portugal
              </div>
              <h2 className="font-display text-white text-4xl sm:text-6xl uppercase leading-[0.92]">
                O seu cliente <br />
                <span className="text-[#ff6b35]">encontra a sua empresa</span> no Google.
              </h2>
              <p className="text-white/75 mt-6 text-lg max-w-md">
                Desenvolvimento web para empresas portuguesas que precisam de mais pedidos de contacto,
                propostas comerciais e autoridade digital no seu mercado.
              </p>
              <a
                data-testid="local-cta"
                href={buildWhatsappLink("Olá! Tenho uma empresa em Portugal e quero saber como a BezierClick pode ajudar no desenvolvimento web B2B.")}
                target="_blank"
                rel="noreferrer"
                className="btn-brutal btn-brutal-orange mt-8"
              >
                Quero atrair leads
              </a>
            </div>

            <div className="lg:col-span-7 space-y-5">
              {items.map((it, i) => {
                const Icon = it.icon;
                return (
                  <div
                    key={it.t}
                    data-testid={`local-item-${i}`}
                    className="bg-[#ff6b35] brutal-border-thick p-5 sm:p-6 flex items-start gap-5 vc-reveal"
                  >
                    <div className="bg-[#0a0a0a] brutal-border w-14 h-14 flex items-center justify-center shrink-0">
                      <Icon size={24} className="text-[#ff6b35]" />
                    </div>
                    <div>
                      <h3 className="font-display uppercase text-[#0a0a0a] text-xl sm:text-2xl">{it.t}</h3>
                      <p className="text-white text-base mt-1">{it.d}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalBusiness;
